var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6C12.2749 6 6 12.2749 6 20C6 27.7251 12.2749 34 20 34C27.7251 34 34 27.7251 34 20C34 12.2749 27.7251 6 20 6ZM13.8113 30.08C15.2185 28.0554 17.5303 26.8205 20 26.8205C22.4697 26.8205 24.7815 28.041 26.2031 30.08C24.3938 31.2 22.2831 31.8462 20 31.8462C17.7169 31.8462 15.6205 31.2 13.8113 30.08ZM27.9118 28.7877C26.0882 26.2031 23.159 24.6667 20 24.6667C16.841 24.6667 13.8974 26.2318 12.0882 28.7877C9.6759 26.6195 8.15385 23.4892 8.15385 20C8.15385 13.4667 13.4667 8.15385 20 8.15385C26.5333 8.15385 31.8462 13.4667 31.8462 20C31.8462 23.4892 30.3241 26.6195 27.9118 28.7877Z",
    fill: "#2AAD75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 11.7437C17.0275 11.7437 14.6152 14.156 14.6152 17.1283C14.6152 20.1006 17.0275 22.5129 19.9998 22.5129C22.9722 22.5129 25.3845 20.1006 25.3845 17.1283C25.3845 14.156 22.9722 11.7437 19.9998 11.7437ZM19.9998 20.359C18.2193 20.359 16.7691 18.9088 16.7691 17.1283C16.7691 15.3478 18.2193 13.8975 19.9998 13.8975C21.7804 13.8975 23.2306 15.3478 23.2306 17.1283C23.2306 18.9088 21.7804 20.359 19.9998 20.359Z",
    fill: "#2AAD75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocials);
export default __webpack_public_path__ + "static/media/socials.427b4ac9.svg";
export { ForwardRef as ReactComponent };